module.exports = __webpack_public_path__ + "static/img/img_main.9c4553d2.png";